'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../../sections/template-account');

require('../../../styles/templates/customers/account.scss');

(0, _themeSections.load)(['template-account']);